// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n@layer tailwind {\nbutton[disabled].bg-main:not(.is-loading) {\n    border-color: var(--surface-4) !important;\n    color: var(--surface-6)\n}\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
